import React from 'react';
import { Col, Container, Input, Label, Row } from 'reactstrap';
import DatePicker from "react-datepicker";
import moment from 'moment';
import Select from 'react-select';
import { mustBeArray } from '../../utils/lib';

const CreateRCTIFilters = props => {
    const {handleFilterChange, filters, rctiCreationDate, handleRCTICreationDateChange, 
            clientList, handleSearch, handleReset, exporting, handleCsvExport} = props;
    return(
        <React.Fragment>
            
        <Row className="align-items-end">
            <Col sm={12} md={7} lg={6}>
                <Row className="align-items-center mb-1" style={{marginBottom: '12px'}}>
                    <Col sm={4} md={3}>
                        <Label for="clientId">Client Name</Label>
                    </Col>
                    <Col sm={8} md={9}>
                        <Select
                            name="clientId"
                            value={filters.clientId}
                            multi={true}
                            clearable={false}
                            simpleValue={true}
                            options={mustBeArray(clientList)}
                            onChange={(value) => handleFilterChange({value, field: "clientId"})}
                            valueKey="id"
                            labelKey="companyName"
                        />
                    </Col>
                </Row>
                <Row className="align-items-center full-width-datepicker" >
                    <Col sm={4} md={3}>
                        <Label for="from" >From</Label>
                    </Col>
                    <Col sm={8} md={4} className="mb-1">
                        <DatePicker
                            onChange={(date) => handleFilterChange({value: date, field: 'dateFrom'})}
                            value={filters.dateFrom}
                            placeholderText="Date From"
                            locale="en-au"
                            readOnly={false}
                            popperPlacement="bottom-end"
                            popperModifiers={{
                            offset: {
                                enabled: true,
                                offset: '5px, 10px'
                            },
                            preventOverflow: {
                                enabled: true,
                                escapeWithReference: false, // force popper to stay in viewport (even when input is scrolled out of view)
                                boundariesElement: 'viewport'
                            }
                            }}
                            className="form-control"
                        />
                    </Col>
                    <Col sm={4} md={1}>
                        <Label for="to" >To</Label>
                    </Col>
                    <Col sm={8} md={4} className="mb-1">
                        <DatePicker
                            onChange={(date) => handleFilterChange({value: date, field: 'dateTo'})}
                            value={filters.dateTo}
                            placeholderText="Date To"
                            locale="en-au"
                            readOnly={false}
                            popperPlacement="bottom-end"
                            popperModifiers={{
                            offset: {
                                enabled: true,
                                offset: '5px, 10px'
                            },
                            preventOverflow: {
                                enabled: true,
                                escapeWithReference: false, // force popper to stay in viewport (even when input is scrolled out of view)
                                boundariesElement: 'viewport'
                            }
                            }}
                            className="form-control"
                            minDate={filters.dateFrom ? moment(filters.dateFrom) : moment()}
                        />
                    </Col>
                </Row>
                <div className="mt-1 mb-3">
                    <button className="btn btn-primary" onClick={handleSearch}>
                        <i className="fa fa-search" aria-hidden="true"></i> &nbsp;Search
                    </button>
                    <button className="btn btn-default ml-2" onClick={handleReset}>
                        Reset
                    </button>
                </div>
                <Row className="mb-1">
                <Col sm={4} md={3}>
                    <Label for="rctiCreationDate" className="mt-h">Date</Label>
                </Col>
                <Col sm={8} md={9}>
                    <DatePicker
                        onChange={(e) => handleRCTICreationDateChange(e)}
                        value={rctiCreationDate}
                        placeholderText="Date"
                        locale="en-au"
                        readOnly={false}
                        popperPlacement="bottom-end"
                        popperModifiers={{
                        offset: {
                            enabled: true,
                            offset: '5px, 10px'
                        },
                        preventOverflow: {
                            enabled: true,
                            escapeWithReference: false, // force popper to stay in viewport (even when input is scrolled out of view)
                            boundariesElement: 'viewport'
                        }
                        }}
                        className="form-control"
                        minDate={moment()}
                    />
                </Col>
            </Row>
            </Col>
            
            <Col sm={12} md={5} lg={6}>
                <div className="float-right mb-1">
                    <button className={`btn btn-success bold ${exporting ? "no-pointer-events" : ""}`} 
                                onClick={handleCsvExport}>
                                    {exporting ?  "Exporting" : "Export CSV"}
                    </button>
                </div>
                <div className="clearfix"/>
            </Col>
        </Row>
        </React.Fragment>
    );
};
export default CreateRCTIFilters;